<template>
  <router-link
    v-for="customer in customers"
    :key="customer.id"
    :to="{ name: 'CustomerPage', params: { id: customer.id } }"
    class="flex items-center gap-2 p-2 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-sm"
  >
    <Image :src="getFlagUrl(customer.country)" :alt="customer.country" class="w-5 h-4" image-class="rounded-sm" />
    <span class="text-sm block">{{ customer.name }}</span>
    <span class="text-sm block">{{ customer.vat }}</span>
  </router-link>
</template>

<script setup>
import { Image } from 'primevue'
import { getFlagUrl } from '@/utils/helpers'

defineProps({
  customers: { type: Array, default: () => [] },
})
</script>
